import {
  useEffect,
  useRef,
  useState,
} from 'react';
import { pdfjs } from 'react-pdf';

import { cleanString } from '../constants';

export default function useLabelsExtraction({
  defaultSignatures,
  defaultFunctions,
}) {
  const [labels, setLabels] = useState(defaultSignatures?.labels);
  const [labelsMatch, setLabelsMatch] = useState(
    defaultSignatures?.labelsMatch,
  );
  const [fieldFunction, setFieldFunction] = useState(defaultFunctions ?? {});
  const [newLabel, setNewLabel] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [openFunctions, setOpenFunctions] = useState({});
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && labels && Object.keys(labels).length > 0) {
      const initialState = {};
      Object.keys(labels).forEach((key) => {
        const cleanedKey = cleanString(key);
        initialState[cleanedKey] = (fieldFunction[key]?.length ?? 0) > 0;
      });
      setOpenFunctions(initialState);
      initialized.current = true;
    }
  }, [labels, fieldFunction]);

  //Lee el PDF y obtiene las etiquetas(Campos)
  const getTextFromPDF = async (pdfFile) => {
    const pdf = await pdfjs.getDocument(pdfFile).promise;
    let extractedStructures = [];

    const regex = /{{\s*(.*?)\s*}}/g;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map((item) => item.str).join(' ');
      const sanitizedText = pageText
        .replace(/\{\s+/g, '{')
        .replace(/\s+\}/g, '}');

      const matches = sanitizedText.match(regex)?.map((match) => {
        return match.replace(/\s+/g, '');
      });

      if (matches) {
        extractedStructures = [...extractedStructures, ...matches];
      }
    }

    const uniqueLabels = [...new Set(extractedStructures)];
    const labelObject = uniqueLabels.reduce((acc, label) => {
      acc[label] = '';
      return acc;
    }, {});

    setLabels(labelObject);
    setLabelsMatch(labelObject);
  };

  const handleAddLabel = () => {
    if (newLabel.trim() !== '' && !labels[newLabel]) {
      setLabels((prev) => ({
        ...prev,
        [newLabel]: '',
      }));
      setLabelsMatch((prev) => ({
        ...prev,
        [newLabel]: '',
      }));
      setNewLabel('');
      setIsAdding(false);
    }
  };

  return {
    labels,
    labelsMatch,
    fieldFunction,
    openFunctions,
    newLabel,
    isAdding,
    setLabels,
    setLabelsMatch,
    setFieldFunction,
    setOpenFunctions,
    setNewLabel,
    setIsAdding,
    getTextFromPDF,
    handleAddLabel,
  };
}
